import ModalBackdrop from "./ModalBackdrop";
import ModalHeader from "./ModalHeader";
import ProfileModal from "../profile/ProfileModal";
import ShareWishesListModal from "../wishes/ShareWishesListModal";
import WishesDataModal from "../wishes/WishesDataModal";
import AddWishModal from "../wishes/AddWishModal";
import avatar from "../../assets/images/avatar.png"
import gift from "../../assets/images/gift.jpg";

const Modal = ({ typeModal = "", imgHeader = [null, "Pas d'image"], headerTitle = "Titre du header" }) => {

    const mainDivCss = `relative m-auto px-3 py-6 bg-slate-200 flex flex-col gap-4 rounded-md text-darkRed shadow-xl shadow-ivroy sm:w-2/3 sm:p-6`
    // wishDataModal
    // global-px py-4

    let headerImg = null
    switch (typeModal) {
        case 'profile':
            headerImg = imgHeader ? imgHeader : [avatar, 'Un avatar']
            break;
        case 'wishData':
            headerImg = imgHeader ? imgHeader : [gift, 'Un cadeau']
            break;
        default:
            headerImg = imgHeader ? imgHeader : [null, "Pas d'image"]
            break;
    }

    const modalDefaultDiv = <>
        <div className={mainDivCss} onClick={e => e.stopPropagation()}>
            <ModalHeader img={headerImg} title={headerTitle} />
            {typeModal === "profile" && <ProfileModal />}
            {typeModal === "wishData" && <WishesDataModal />}
            {typeModal === "addWish" && <AddWishModal />}
        </div>
    </>

    return (
        <ModalBackdrop>
            {typeModal === "shareList" ? <ShareWishesListModal /> : modalDefaultDiv}
        </ModalBackdrop>
    );
};

export default Modal;